import React, { useEffect } from "react";
import { Alert, Col, Container, Row } from "reactstrap";

import Header from "./Header";
import MainDetails from "./MainDetails";
import AdditionalDetails from "./AdditionalDetails";
import { useParams, useLocation } from "react-router-dom";
import { usePageActivity } from "Components/Hooks/UsePageActivity";
import BreadCrumb from "Components/Common/BreadCrumb";
import { getUnDesignatedItem } from "common/services/sanctions-list.service";
import { normalize } from "common/lib/normalize";
import { toast } from "react-toastify";

const ViewUNDesignatedItem = () => {
  const location = useLocation();
  const { id: itemId } = useParams();
  usePageActivity(location.pathname, "View UN Designated List", itemId);

  const [, setLoading] = React.useState<boolean>(false);
  const [data, setData] = React.useState<any>({});
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await getUnDesignatedItem(itemId, {});
        setData(normalize(response.data));
      } catch (error) {
        toast.error("Error while fetching data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [itemId]);

  document.title = "UN Designated List | CIMS";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="UN Designated List Details"
            pageTitles={[
              {
                title: "Dashboard",
                link: "/",
              },
              {
                title: "UN Designated List",
                link: "/sanctions-list/un-designated",
              },
            ]}
            back
          />
          <Row>
            <Col>
              <Alert color="danger" className="material-shadow">
                <strong> UN Security Council Sanction! </strong> This entity has
                been sanctioned by the UN Security Council. Please check the
                profile below for more information.
              </Alert>
            </Col>
          </Row>
          <Row>
            <Header data={data} />
          </Row>
          <Row>
            <MainDetails data={data} />
            <AdditionalDetails data={data} />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ViewUNDesignatedItem;
